import { VisuallyHidden as RadixVisuallyHidden } from '@radix-ui/react-visually-hidden'

import type { JSX } from 'react'

export function VisuallyHidden({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  return (
    <RadixVisuallyHidden
      {...{ inert: true }} // Prevent content from coming up in browser search results (i.e. cmd+f).
    >
      {children}
    </RadixVisuallyHidden>
  )
}
